module.exports = __webpack_public_path__ + "img/07-install-step-2-unknown-sources.1e42b8a3.webp";